export { default as PersonalInfoList } from './PersonalInfoList'
export { default as PersonalInfoFilter } from './PersonalInfoFilter'




// WEBPACK FOOTER //
// ./src/views/AdminCentre/components/index.js